{
  "recommendedAssetMix": "Nous vous recommandons cette répartition d'actifs",
  "factorAffectingScore": "Facteur affectant votre score",
  "riskProfileIs": "Votre profil de risque est",
  "factorAffectingScoreDescription": "Les facteurs suivants influencent votre profil de risque.",
  "investmentKnowledge": "Connaissance en investissement",
  "investmentKnowledgeOptions": {
    "NONE": "Aucun",
    "LIMITED": "Limité",
    "SOME": "En partie",
    "EXPERT": "Expert"
  },
  "timeHorizon": "Horizon temporel",
  "goalTimeHorizon": {
    "VERY_SHORT_TERM": "Très court terme",
    "SHORT_TERM": "Court terme",
    "MID_TERM": "Moyen terme",
    "LONG_TERM": "Long terme",
    "VERY_LONG_TERM": "Très Long Terme"
  },
  "riskProfileIsNotAvailable": "Pas disponible.",
  "previewRiskProfileName": "Moyen",
  "previewRiskProfileDescription": "Pour les clients prêts à accepter un niveau de risque modéré. Vous cherchez à obtenir des rendements potentiels élevés à moyen et long terme dans des conditions de marché normales."
}
